<template>
  <div>
    <rotation-plot-component />

    <div class="div_technology">
      <div style="margin: 30px auto; padding-top: 30px; font-size: 24px">
        {{ mainObj.technologyTitle }}
      </div>
      <el-row style="max-width: 1200px; margin: 0 auto">
        <el-col
          :span="6"
          v-for="(item, index) in mainObj.technologyList"
          :key="index"
        >
          <el-image :src="item.picture" style="width: 290px; height: 319px" />
          <h2 style="margin: 10px auto 15px">{{ item.title }}</h2>
        </el-col>
      </el-row>
    </div>

    <div class="div_project">
      <div
        style="
          background-color: #ffffff;
          line-height: 50px;
          font-size: 24px;
          width: 200px;
          margin: 0 auto;
        "
      >
        <span>行业解决方案</span>
      </div>
      <div class="flexBox">
        <div v-for="(item, index) in solutionList" :key="index">
          <div
            @mouseenter="showChange(index, true)"
            @mouseleave="showChange(index, false)"
            style="
              display: flex;
              flex-direction: column;
              margin: 30px 20px 0;
              cursor: pointer;
            "
          >
            <el-image
              :src="item.picture"
              :style="{
                border:
                  index === 0 || index === 3 ? '1px solid #FFFFFF' : 'none',
              }"
              class="image_project"
            />
            <span
              style="line-height: 40px"
              :style="{
                'font-weight': item.title === nowShow.title ? 'bold' : 'normal',
              }"
              >{{ item.title }}</span
            >
          </div>
        </div>
      </div>
      <div
        style="background-color: #ffc300; height: 40px; margin-top: -40px"
      ></div>
    </div>

    <div class="project_detail">
      <div class="project_detail_content">
        <span class="project_detail_title">{{ nowShow.title }}</span>
        <div style="margin-top: 50px">{{ nowShow.content }}</div>
      </div>
      <el-image :src="nowShow.picture" class="project_detail_pic" />
    </div>
  </div>
</template>

<script>
import rotationPlotComponent from "@/components/rotationPlotComponent/rotationPlotComponent";

export default {
  name: "Main",
  components: { rotationPlotComponent },
  data() {
    return {
      mainObj: global.mainObj,
      solutionList: global.mainObj.solutionList,
      nowShow: {},
    };
  },
  created() {
    this.nowShow = this.solutionList[0];
  },
  methods: {
    showChange(index, now) {
      for (let i = 0; i < this.solutionList.length; i++) {
        this.solutionList[i].isHover = i === index ? now : false;
      }
      const i = this.solutionList.findIndex((val) => val.isHover);
      if (i > -1) this.nowShow = this.solutionList[i];
    },
  },
};
</script>

<style scoped>
.div_technology {
  margin-top: 50px;
  width: 100%;
  min-width: 1200px;
  background-color: #e6e6e6;
}

.div_project {
  margin: 50px auto 0;
  width: 1200px;
  background: url("../assets/img/mainPage/projectBackground.jpg") no-repeat
    scroll 50% 50%;
  background-size: cover;
  height: 450px;
  padding-top: 68px;
}
.image_project {
  width: 200px;
  height: 135px;
  padding: 5px 25px 0;
}

.project_detail {
  width: 1140px;
  display: flex;
  margin: 0 auto;
  padding: 30px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
  border-radius: 0 0 5px 5px;
}
.project_detail_content {
  width: 550px;
  text-align: left;
  margin-right: 40px;
}
.project_detail_title {
  font-size: 20px;
  font-weight: bold;
  line-height: 25px;
  border-bottom: 3px solid #07c7ae;
}
.project_detail_pic {
  width: 550px;
  height: 330px;
}
</style>



// WEBPACK FOOTER //
// src/views/main.vue